<template lang="html">

    <head :sticky="isSticky" :opened="showMenuResponsive">
        <section class="top-header">
            <div class="container">
                <router-link class="logo-responsive row-start" to="/">
                    <img :src="brand.logo" alt="logo">
                </router-link>
                <router-link class="logout" :to="$t('enlaces.logout')">{{
                    $t('header.cerrar_sesion') }}</router-link>
                <div class="contenedor-texto row-end" v-if="logged">
                    <router-link v-if="!!personales & isAlumno" class="nombre" to="/cv">{{ $t('header.hola') }}
                        {{ personales }}</router-link>
                    <router-link v-if="!!personales & isEmpresa" class="nombre" to="/mi-perfil">{{ $t('header.hola') }}
                        {{ personales }}</router-link>
                    <notificaciones></notificaciones>
                    <button type="button" class="btn-menu" @click="showMenuResponsive = !showMenuResponsive;"
                        aria-label="Abrir/Cerrar menú" title="Abrir/Cerrar menú">
                        <span v-if="showMenuResponsive" class="cerrar-menu">✕</span>
                        <span class="show-menu" v-else>
                            <i></i>
                            <i></i>
                            <i></i>
                        </span>
                    </button>
                </div>
            </div>
        </section>
        <section class="subheader" :opened="showMenuResponsive">
            <router-link class="logo row-start" to="/">
                <img :src="brand.logocolor" alt="logo">
            </router-link>
            <div class="ul-links">
                <template v-if="isAlumno">
                    <template v-if="!!ofertasParams.practicas.numTotal">
                        <router-link :to="$t('enlaces.ofertas_practicas')" class="main">{{
                            $t('header.ofertas')
                        }}</router-link>
                    </template>
                    <template  v-if="showPropuestaPracticas && brand.siteEmpresa.showPropuestaPracticas && brand.siteAlumnos.showPropuestaPracticas && hasPracticas">
                        <router-link class="main" :to="$t('enlaces.propuesta_practicas')">{{
                            $t('header.propuesta_practicas') }}</router-link>
                    </template>
                    <template v-if="!!ofertasParams.empleo.numTotal && brand.agenciaColocacion">
                        <router-link :to="$t('enlaces.ofertas_empleo')" class="main">{{
                            $t('header.oferta_empleo')
                            }}</router-link>
                    </template>
                    <router-link v-if="isAlumno && !hasPracticas && brand.siteAlumnos.showMisCandidaturas && brand.agenciaColocacion"
                        :to="$t('enlaces.mis_candidaturas_candidatos')" class="main">
                        {{ $t('header.candidaturas') }}
                    </router-link>
                    <router-link v-if="isAlumno && brand.siteAlumnos.showMisCandidaturas && hasPracticas"
                        :to="$t('enlaces.mis_candidaturas')" class="main">
                        {{ $t('header.candidaturas') }}
                    </router-link>
                    <router-link v-i
                    <router-link v-if="hasPracticas" :to="$t('enlaces.mis_practicas')" class="main">
                        {{ $t('header.practicas') }}
                    </router-link>

                    <router-link v-if="isAlumno && brand.siteAlumnos.showMisEncuestas && encuestas.length > 0"
                        to="/#encuestas" class="main">
                        {{ $t('header.encuestas') }}
                    </router-link>
                    <router-link :to="$t('enlaces.cv')" class="main">{{
                        $t('header.perfil') }}</router-link>

                    <router-link v-if="brand.hasGuiasOrientacion" :to="$t('enlaces.guiaOrientacion')" class="main">{{
                        $t('header.guias_orientacion')
                        }}</router-link>

                </template>
                <template v-if="isEmpresa">
                    <router-link :to="$t('enlaces.mis_ofertas')" class="main">{{
                        $t('header.mis_ofertas') }}
                    </router-link>

                    <router-link :to="$t('enlaces.nueva_oferta')" class="main">{{
                        $t('header.nueva_oferta') }}
                    </router-link>

                    <template
                        v-if="showPropuestaPracticas && brand.siteEmpresa.showPropuestaPracticas && brand.siteAlumnos.showPropuestaPracticas ">
                        <span class="main" v-if="brand.inactiveOfertasPracticas" :class="{'tooltip-disabled': brand.inactiveOfertasPracticas}" :text-tooltip="$t('header.proximamente')">{{
                            $t('header.propuesta_practicas') }}</span>
                        <router-link v-else class="main" :to="$t('enlaces.propuesta_practicas')" >{{
                            $t('header.propuesta_practicas') }}</router-link>
                    </template>

                    <template v-if="brand.canCambiarPracticas">
                        <router-link class="main" :to="$t('enlaces.solicitarcambiopracticas')">{{
                            $t('header.solicitar_cambio_practicas')
                            }}</router-link>
                    </template>

                    <template v-if="brand.hasProgramaPracticasActivo">
                        <router-link :to="$t('enlaces.programapracticasactivos')" class="main">{{ $t('header.programas')
                            }}
                        </router-link>
                    </template>
                    <span class="main" v-if="brand.inactiveOfertasPracticas" :class="{'tooltip-disabled': brand.inactiveOfertasPracticas}"  :text-tooltip="$t('header.proximamente')">{{ $t('header.documentacion') }}</span>
                    <router-link v-else class="main" :to="$t('enlaces.documentacion')">{{
                        $t('header.documentacion') }}
                    </router-link>

                    <template v-if="hasMenuEducacion && solicitudesEducacion.length != 0">
                        <router-link class="main" :to="$t('enlaces.practicaseducacion')">{{
                            $t('header.solicitudes_practicas_educacion') }}
                        </router-link>
                    </template>
                    <router-link :style="style.fontSecondary" :to="$t('enlaces.mi_perfil')" class="main">{{
                        $t('encabezado.mi_perfil') }}
                    </router-link>

                    <router-link :to="$t('enlaces.mi_empresa')" class="main">{{
                        $t('header.mi_empresa') }}
                    </router-link>

                </template>
                <router-link class="logout" :to="$t('enlaces.logout')">{{
                    $t('header.cerrar_sesion') }}</router-link>

            </div>
        </section>
    </head>
</template>
<script lang="js">

import { mapActions, mapGetters } from 'vuex';

import Notificaciones from '@/components/parts/notificaciones'

import router from '@/router';

import Vue from 'vue'


export default {
    name: 'app-header',
    data() {
        return {
            isSticky: false,
            showMenuResponsive: false,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            this.isSticky = window.scrollY > 0
        }
    },
    computed: {
        ...mapGetters({
            isAlumno: 'isAlumno',
            isEmpresa: 'isEmpresa',
            style: 'getStyles',
            colors: 'basicColors',
            logo: 'getLogo',
            logocolor: 'getLogoColor',
            logoencabezado: 'getLogoEncabezado',
            logosize: 'getLogoSize',
            personales: 'getUserName',
            logged: 'getLogged',
            ofertasParams: 'getParamsOfertas',
            darkmode: 'getDarkSide',
            hasPracticas: 'hasPracticas',
            getShowPropuestaPracticas: 'getShowPropuestaPracticas',
            version: 'getVersion',
            brand: 'getBrand',
            inproduction: 'getInProduction',
            hasMenuEducacion: 'getMenuEducacion',
            solicitudesEducacion: 'getsolicitudesEducacion',
            soloCiclosUAX: 'getsoloCiclosUAX',
            encuestas: "getEncuestas"
        }),
        showPropuestaPracticas() {
            let show;

            if (typeof this.getShowPropuestaPracticas == 'string') {
                show = (this[this.getShowPropuestaPracticas]);
            } else {
                show = this.getShowPropuestaPracticas
            }

            return show;
        },
        islocalhost() {
            return (window.location.hostname == 'localhost');
        }
    },
    components: {
        'notificaciones': Notificaciones
    },
    watch: {
        '$route': function () {
            this.showMenuResponsive = false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/header.vue